import React from 'react';
import Icon from '../../../components/AppIcon';

const ComplianceSection = () => {
  const standards = [
    {
      title: 'NACVA Standards',
      description: 'Full compliance with NACVA standards for business valuation',
      features: [
        'Recognized framework',
        'Evidence-based analysis',
        'Documented assumptions'
      ],
      icon: 'Globe'
    },
    {
      title: 'AICPA Business Valuation Standards',
      description: 'Adherence to American Institute of CPAs professional standards',
      features: [
        'SSVS No. 1: Valuation Services',
        'Professional competence requirements',
        'Independence and objectivity'
      ],
      icon: 'Award'
    },
    {
      title: 'Professional Conduct',
      // description: 'Regional considerations for others business environments',
      features: [
        'Strict confidentiality',
        'Ethical practice',
        'Quality review'
      ],
      icon: 'MapPin'
    }
  ];

  const certifications = [
    {
      title: 'Certified Valuation Analyst (CVA)',
      // issuer: 'National Association of Certified Valuators and Analysts',
      description: ' Recognized valuation credential held by qualified financial professionals',
      icon: 'Award'
    },
    {
      title: 'Court-Nominable Expert',
      // issuer: 'Regional Court Systems',
      description: ' Qualified to support legal proceedings and expert testimony requirements',
      icon: 'Scale'
    },
    {
      title: 'Professional Memberships',
      // issuer: 'Industry Associations',
      description: ' Active engagement in valuation and financial professional associations',
      icon: 'Users'
    }
  ];

  const qualityAssurance = [
    {
      step: 'Peer Review',
      description: 'Independent review by senior valuation professionals',
      icon: 'UserCheck'
    },
    {
      step: 'Technical Review',
      description: 'Comprehensive analysis of methodology and calculations',
      icon: 'Search'
    },
    {
      step: 'Quality Control',
      description: 'Final verification of report accuracy and completeness',
      icon: 'CheckCircle'
    },
    {
      step: 'Client Review',
      description: 'Draft presentation and feedback incorporation',
      icon: 'MessageSquare'
    }
  ];

  return (
    <section className="py-20 bg-muted">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-3xl lg:text-4xl font-bold text-primary mb-6">
            Standards & Compliance
          </h2>
          <p className="text-xl text-text-secondary leading-relaxed">
            Our valuations meet the highest professional standards and are designed to withstand scrutiny in any forum, from boardrooms to courtrooms.
          </p>
        </div>

        {/* Professional Standards */}
        <div className="mb-16">
          <h3 className="text-2xl font-bold text-primary mb-8 text-center">Professional Standards</h3>

          <div className="grid lg:grid-cols-3 gap-8">
            {standards?.map((standard, index) => (
              <div key={index} className="bg-white rounded-xl p-8 border border-border hover:shadow-brand transition-shadow duration-300">
                <div className="flex items-center space-x-4 mb-6">
                  <div className="w-12 h-12 bg-accent/10 rounded-lg flex items-center justify-center">
                    <Icon name={standard?.icon} size={24} className="text-accent" />
                  </div>
                  <h4 className="text-lg font-semibold text-primary">{standard?.title}</h4>
                </div>

                <p className="text-text-secondary mb-6">{standard?.description}</p>

                <ul className="space-y-3">
                  {standard?.features?.map((feature, idx) => (
                    <li key={idx} className="flex items-start space-x-3">
                      <Icon name="CheckCircle" size={16} className="text-success flex-shrink-0 mt-0.5" />
                      <span className="text-sm text-text-primary">{feature}</span>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        {/* Certifications */}
        <div className="mb-16">
          <h3 className="text-2xl font-bold text-primary mb-8 text-center">Professional Credentials</h3>

          <div className="grid md:grid-cols-3 gap-6">
            {certifications?.map((cert, index) => (
              <div key={index} className="bg-white rounded-xl p-6 border border-border text-center hover:shadow-brand transition-shadow duration-300">
                <div className="w-16 h-16 bg-accent/10 rounded-full flex items-center justify-center mx-auto mb-4">
                  <Icon name={cert?.icon} size={28} className="text-accent" />
                </div>

                <h4 className="text-lg font-semibold text-primary mb-2">{cert?.title}</h4>
                <p className="text-sm text-accent font-medium mb-3">{cert?.issuer}</p>
                <p className="text-sm text-text-secondary">{cert?.description}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Quality Assurance Process */}
        {/* <div>
          <h3 className="text-2xl font-bold text-primary mb-8 text-center">Quality Assurance Process</h3>
          
          <div className="bg-white rounded-2xl p-8 border border-border">
            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
              {qualityAssurance?.map((step, index) => (
                <div key={index} className="text-center">
                  <div className="relative mb-6">
                    <div className="w-16 h-16 bg-accent/10 rounded-full flex items-center justify-center mx-auto">
                      <Icon name={step?.icon} size={24} className="text-accent" />
                    </div>
                    <div className="absolute -top-2 -right-2 w-6 h-6 bg-accent text-white rounded-full flex items-center justify-center text-xs font-bold">
                      {index + 1}
                    </div>
                  </div>
                  
                  <h4 className="text-lg font-semibold text-primary mb-3">{step?.step}</h4>
                  <p className="text-sm text-text-secondary">{step?.description}</p>
                  
                  {index < qualityAssurance?.length - 1 && (
                    <div className="hidden lg:block absolute top-1/2 left-full w-8 transform -translate-y-1/2 -translate-x-4">
                      <Icon name="ArrowRight" size={20} className="text-border" />
                    </div>
                  )}
                </div>
              ))}
            </div>
            
            <div className="mt-8 pt-8 border-t border-border text-center">
              <div className="inline-flex items-center px-6 py-3 bg-success/10 border border-success/20 rounded-full">
                <Icon name="Shield" size={20} className="text-success mr-3" />
                <span className="text-success font-medium">Court-Admissible Reports Guaranteed</span>
              </div>
            </div>
          </div>
        </div> */}
      </div>
    </section>
  );
};

export default ComplianceSection;